import React from 'react';
import axios2 from 'services/axios2';
import { ToastContainer, toast } from 'react-toastify';

import { withRouterJim } from "router/withRouterJim";

import { Link } from "react-router-dom";


import NuDropdown from 'components/nubox/NuDropdown';
import NuLoading from 'components/nubox/NuLoading';

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class ImportarEst extends React.Component {

  myRef = React.createRef();//create ref
  
  state = {
    isloading: false,
    image_file: null, /*archivo a subir */
    image_preview: '',

    form: {  
      id_peri:0,
      fecha:'',
    },

    data: [],/* lista  */
    materias: [],
  };

  //-----------------------------------------------

  //------------------------------------------------------
  componentDidMount() {
    console.log("componentDidMount citas");
    //--limpiamos el array de prueba
    this.setState({ data: [] });

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //this.setState({fechai: defaultValue}); 
    let user = this.props.store.user
    let id_peri = user.id_peri

    this.setState({ form: { ...this.state.form, 
                          fecha: defaultValue, 
                          'id_peri':id_peri} });

    //this.cargar_materias();
    //this.cargar_citas();
    //this.fetchData(this.state.fechai);


  }
  //--------------------------------------------------
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  // Image Preview Handler
  handleImagePreview = (e) => {
    //let image_as_base64 = URL.createObjectURL(e.target.files[0])
    let image_as_files = e.target.files[0];

    this.setState({
        //image_preview: image_as_base64,
        image_file: image_as_files,
    })
}
  //-----------------------------------------
 
  //-------------------------------------------
  /*onSubmitHandler= (event)=>{
    event.preventDefault();

    this.handleSubmitFile ();
  }*/
  //-----------------------------------
  handleSubmitFile  =(e) =>{
    e.preventDefault();
    //const id_paciente = this.props.store.paciente.id_paciente;

    const URL = "imp_est_save";
    const data = new FormData();

  
    data.append("id_peri", this.state.form.id_peri);
    data.append("file", this.state.image_file);
    //data.append("imageFile", this.state.image_file);
    const config = {
        header: {
            //"Content-Type": "image/png",
            "Content-Type": "text/csv",
        },
    };

    this.setState({ isloading: true })
    
    axios2.post(URL, data, config) 
    .then(res => {
        this.setState({ isloading: false })

        if(res.data.exito === 1){ 
            //toast.success(res.data.mensaje); 
          this.setState({data: res.data.data});
        }else{
            toast.error(res.data.mensaje);
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------

  render() {

    return (
      <div>
        <ToastContainer />
        {
          //JSON.stringify(this.state.form)
        }
        <br/>
        <div className="container">
          <form >
              <div className='text-center'>
              <h3>Importar estudiantes</h3>
              </div>

              <div className="alert alert-info">
                <strong>Nota:</strong> Utilice la siguiente plantilla
              </div>
      
              <div className="table-responsive">
                <table className="table">
                  <tbody>
                  
                    <tr>
                      <td>
                        <label>MODELO ARCHIVO.CSV:</label>
                      </td>
                      <td>
                        <a href={ process.env.REACT_APP_AFILES_RESET + "importar-est.csv"  }>modelo archivo 2</a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>ARCHIVO PARA SUBIR:</label>
                      </td>
                      <td>
                        {/* image input field */}
                        <input
                          type="file" name="file"
                          onChange={this.handleImagePreview}
                        />
                      </td>
                    </tr>
                  </tbody></table>
              </div>
              <div className="row" style={{ padding: "5px" }}>
                <div className="col-md-12" align="center">
                  
                  
                  <NuLoading
                    className=''
                    show={ this.state.isloading }
                    text="Cargando..."
                    style={{ width: 120 }}
                  />
                  
                  <button 
                    className="btn btn-primary" 
                    onClick={this.handleSubmitFile}
                  >Aceptar y subir</button>

                </div>

                
              </div>
            
          </form>
          <br/>

        </div>

        <div className="container">
          <div className="col-md-12">
            <div id="divres">
              <table className="table table-hover table-bordered table-striped ui-sortable">
                <tbody>
                  <tr>
                    <th>Nº</th>
                    <th>CI</th>
                    <th>Nombre</th>
                    <th>Obs.</th>
                  </tr>
                  {this.state.data.map((item, index) => (
                    <tr key={index}>
                      
                      <td>{ index + 1 }</td>
                      <td>{item.ci}</td>
                      <td>{item.nomape}</td>
                      <td>
                        <span className="badge rounded-pill bg-success">{item.cad_nuevo}</span>
                        <div className="badge rounded-pill bg-info text-dark">{item.cad_sigla}</div>
                      </td>

                      
                    </tr>
                  ))}
                  
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouterJim(ImportarEst);